import {useMemo} from 'react';
import {useQuery} from 'react-query';

const buildSingleFetch = (value, fetchFunc) => {
  const fetch = async () => {
    const data = await fetchFunc?.(value);
    return data.data;
  };

  const isEnabled = (value && fetchFunc) ? typeof value === 'string' : false;

  return {fetch, isEnabled};
};

const buildMultiFetch = (value, fetchFunc) => {
  const payload = {
    filters: {
      type: 'IN',
      field: '_id',
      value: value,
      objectId: true
    },
    size: value.length
  };

  const fetch = async () => {
    const data = await fetchFunc?.(payload);
    // eslint-disable-next-line no-prototype-builtins
    return data?.hasOwnProperty('hasMore') && data?.hasOwnProperty('total') ? data.data : data;
  };

  const isEnabled = (value && value.length && fetchFunc) ? !value.some(val => typeof val !== 'string') : false;
  return {fetch, isEnabled};
};

export const useFindValue = (fetchFunc, value, enabled) => {

  const {fetch, isEnabled} = useMemo(() => {
    if (!Array.isArray(value))
      return buildSingleFetch(value, fetchFunc);
    return buildMultiFetch(value, fetchFunc);
  }, [value, fetchFunc]);

  const {
    isLoading,
    data,
    error,
    isError,
  } = useQuery([value], fetch, {staleTime: 2000, enabled: Boolean(enabled) && isEnabled});

  if (enabled && isEnabled) {
    return {
      isLoading,
      data: data || value,
      isError,
      error
    };
  }

  return {
    isLoading: false,
    data: value,
    isError: false
  };
};
